module.exports = __webpack_public_path__ + "static/media/marina.0b16f900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/marina.png
// module id = 1183
// module chunks = 0